import { Input } from 'antd';

export const BaseInput = ({ placeholder = '', value, width, onChange }) => {
  const onHandleChange = (e) => {
    const { target : { value: newValue } } = e;
    if (onChange) onChange(newValue);
  }
  return <Input placeholder={placeholder} style={{ width }} value={value} onChange={onHandleChange} />;
};